import { render, staticRenderFns } from "./pvscan-mobile-carousel.vue?vue&type=template&id=535bf15f&scoped=true"
import script from "./pvscan-mobile-carousel.vue?vue&type=script&lang=js"
export * from "./pvscan-mobile-carousel.vue?vue&type=script&lang=js"
import style0 from "./pvscan-mobile-carousel.vue?vue&type=style&index=0&id=535bf15f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bf15f",
  null
  
)

export default component.exports